import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelectLanguage } from '../../hooks/global/Languages';

export default function CheckBox({ value, question, onChange, sourceId }) {
  const { t, i18n } = useTranslation();
  const lng = i18n.language.toUpperCase();
  const id = question.id + "" + sourceId;
  const [ checked, setChecked ] = useState(value);
  const { selectTextByLanguage } = useSelectLanguage()

  const handleChange = (score) => {
    setChecked(!checked);
    onChange?.(question, checked);
  }

  return (
    <div className="reviewInvite-customCheckbox reviewInvite-customCheckboxGeneral">
      <div className="reviewInvite-question clearfix">
        <input type="checkbox"
          onChange={handleChange}
          checked={checked}
          id={id} />
        <label htmlFor={id}>{selectTextByLanguage(question.text,lng)}</label>
      </div>
    </div>
  )
}
